import * as THREE from "three";

export const PAPER = [
  {
    name: "Paper Matt",
    listName: "PAPER",
    // normalMap: "./textures/paper/paper02/normal.jpg",
    // roughnessMap: "./textures/paper/paper02/roughness.jpg",
    size: [2, 2, 2],
    offset: [0.0, 0.0],
    roughness: 1,
    metalness: 0,
    rotation: 0,
    space: THREE.SRGBColorSpace,
    envMapIntensity: 2,
    toneMapped: false,
  },
  {
    name: "Paper Semi Gloss",
    listName: "PAPER",
    // normalMap: "./textures/paper/paper02/normal.jpg",
    // roughnessMap: "./textures/paper/paper02/roughness.jpg",
    size: [2, 2, 2],
    offset: [0.0, 0.0],
    roughness: 1,
    metalness: 0,
    rotation: 0,
    space: THREE.SRGBColorSpace,
    envMapIntensity: 2,
    toneMapped: false,
  },

  {
    name: "ChrMatt",
    listName: "PAPER",
    normalMap: null,
    roughnessMap: null,
    size: [1, 1, 1],
    offset: [0.0, 0.0],
    roughness: 0.1,
    metalness: 0.1,
    rotation: 0,
    space: THREE.SRGBColorSpace,
    envMapIntensity: 1,
    toneMapped: false,
  },
  {
    name: "ChrGlossy",
    listName: "PAPER",
    normalMap: null,
    roughnessMap: null,
    size: [1, 1, 1],
    offset: [0.0, 0.0],
    roughness: 0.0,
    metalness: 0.1,
    rotation: 0,
    space: THREE.SRGBColorSpace,
    envMapIntensity: 1,
    toneMapped: false,
  },
  {
    name: "ChrMetalicGlossy",
    listName: "PAPER",
    normalMap: null,
    // roughnessMap:
    //   "./textures/paper/MetalSteelBrushed001/MetalSteelBrushed001_ROUGHNESS_1K_METALNESS.png",
    // matelnessMap:
    //   "./textures/paper/MetalSteelBrushed001/MetalSteelBrushed001_METALNESS_1K_METALNESS.png",
    //aoMap: "./textures/paper/MetalSteelBrushed001/Metal032_2K-JPG_Roughness2.jpg",
    size: [1, 1, 1],
    offset: [0.0, 0.0],
    roughness: 1.0,
    metalness: 0.5,
    rotation: 0,
    space: THREE.SRGBColorSpace,
    envMapIntensity: 1,
    toneMapped: false,
  },
  {
    name: "ChrMetalicMatt",
    listName: "PAPER",
    normalMap: null,
    // roughnessMap:
    //   "./textures/paper/MetalSteelBrushed001/MetalSteelBrushed001_ROUGHNESS_1K_METALNESS.png",
    // matelnessMap:
    //   "./textures/paper/MetalSteelBrushed001/MetalSteelBrushed001_METALNESS_1K_METALNESS.png",
    //aoMap: "./textures/paper/MetalSteelBrushed001/Metal032_2K-JPG_Roughness2.jpg",
    size: [1, 1, 1],
    offset: [0.0, 0.0],
    roughness: 1.0,
    metalness: 0.5,
    rotation: 0,
    space: THREE.SRGBColorSpace,
    envMapIntensity: 1,
    toneMapped: false,
  },
];
